import {
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  Select,
  SelectItem,
  Switch,
} from "@heroui/react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import { Search, Settings2 } from "lucide-react";
import { LimeInput } from "@/Components/NextBase/LimeInput";

type SortOption = "createdAtAsc" | "createdAtDesc";

export const SubscriptionsFilter = ({
  searchQuery,
  setSearchQuery,
  sortBy,
  setSortBy,
  showInactive,
  setShowInactive,
}: {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  sortBy: SortOption;
  setSortBy: (sort: SortOption) => void;
  showInactive: boolean;
  setShowInactive: (show: boolean) => void;
}) => {
  const sortOptions = [
    { key: "createdAtDesc", label: t`Datumu nastanka (novejši najprej)` },
    { key: "createdAtAsc", label: t`Datumu nastanka (starejši najprej)` },
  ];

  return (
    <div className="flex items-end justify-start gap-3">
      <LimeInput
        isClearable
        variant="bordered"
        className="w-full sm:max-w-[30%]"
        autoFocus
        placeholder={t`Iskanje po imenu...`}
        startContent={<Search className="text-gray-400" size={16} />}
        value={searchQuery}
        onClear={() => {
          setSearchQuery("");
        }}
        onValueChange={setSearchQuery}
      />
      <Popover>
        <PopoverTrigger>
          <Button
            isIconOnly
            variant="flat"
            startContent={<Settings2 size={20} />}
          ></Button>
        </PopoverTrigger>
        <PopoverContent className="flex items-start justify-start gap-4 p-4">
          <Select
            label={t`Razrsti po`}
            selectedKeys={new Set([sortBy])}
            onSelectionChange={(keys) => {
              const key = Array.from(keys)[0] as SortOption;
              if (key) {
                setSortBy(key);
              }
            }}
            className="w-full"
          >
            {sortOptions.map((option) => (
              <SelectItem key={option.key}>{option.label}</SelectItem>
            ))}
          </Select>
          <Switch
            size="sm"
            isSelected={showInactive}
            onValueChange={(value) => {
              setShowInactive(value);
            }}
          >
            <Trans>Prikaži neaktivne naročnine</Trans>
          </Switch>
        </PopoverContent>
      </Popover>
    </div>
  );
};
